import type { SessionView } from '@pricechime/contracts'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { api, setCsrfToken } from '../api/client'

export const useSessionStore = defineStore('session', () => {
  const session = ref<SessionView>({ authenticated: false })
  const loaded = ref(false)
  const user = computed(() => session.value.user)
  const isAdmin = computed(() => user.value?.role === 'admin')
  async function refresh(): Promise<void> {
    session.value = await api<SessionView>('/api/session')
    setCsrfToken(session.value.csrfToken)
    loaded.value = true
  }
  async function logout(): Promise<void> {
    await api('/api/auth/logout', { method: 'POST' })
    setCsrfToken(undefined)
    session.value = { authenticated: false }
  }
  return { session, loaded, user, isAdmin, refresh, logout }
})
